import React, { useEffect, useState, useRef } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  Avatar,
  Form,
  Input,
  Select,
  Upload,
  Typography,
  Checkbox,
  Spin,
  Alert,
  Modal,
} from "antd";
import {
  UserOutlined,
  SaveOutlined,
  PhoneOutlined,
  CommentOutlined,
  UploadOutlined,
  ArrowLeftOutlined,
  LockOutlined,
  CameraOutlined,
  FolderOpenOutlined,
} from "@ant-design/icons";
import { TbCurrencyRupee } from "react-icons/tb";
import { useNavigate, useParams } from "react-router-dom";
import {
  useGetUserProfileByIdQuery,
  useSubmitConsultantApplicationByExitingUserMutation,
  useSubmitConsultantApplicationMutation,
} from "../../redux/rtk/apiRtk";
import { uploadImageToCloudinary } from "../../utils/imageUpload";
import { ToastContainer, toast } from "react-toastify";
import { motion } from "framer-motion";
import { consultantCategory } from "../../components/consultantCategory";
import { primaryColor } from "../../utils/constants";

const { Option } = Select;
const { Title, Text } = Typography;
const emptyData = {
  id: "",
  phone: "",
  email: "",
  password: "",
  about: "",
  pricePerMinute: "",
  communicationType: [],
  image: "",
  firstName: "",
  lastName: "",
  category: [],
};
export const BecomeConsultant = () => {
  const { id } = useParams();
  const { data: profile, error, isLoading } = useGetUserProfileByIdQuery(id);
  const navigate = useNavigate();
  // console.log({ id, profile, isLoading, error });

  // Check if user is verified (coming from OTP verification)

  const [submitApplication, { isLoading: isSubmittingApplication }] =
    useSubmitConsultantApplicationMutation();
  const [submitApplicationExisted, { isLoading: isSubmittingApplication1 }] =
    useSubmitConsultantApplicationByExitingUserMutation();
  // State
  const [formData, setFormData] = useState(emptyData);
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [animateProfile, setAnimateProfile] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);

  // Refs
  const fileInputRef = useRef(null);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  // Form
  const [form] = Form.useForm();

  // Animation effect
  useEffect(() => {
    setTimeout(() => {
      setAnimateProfile(true);
    }, 100);
  }, []);

  useEffect(() => {
    if (profile) {
      const prefilledData = {
        firstName: profile.firstName,
        id,
        lastName: profile.lastName,
        // email: profile?.user?.email,
        phone:
          profile?.user?.phone === 0
            ? ""
            : String(profile?.user?.phone).slice(-10),
      };

      // Update form data state
      setFormData((prev) => ({
        ...prev,
        ...prefilledData,
      }));
      console.log({ prefilledData });

      // Set form field values for prefilled data (hidden fields)
      form.setFieldsValue(prefilledData);
    }

    return () => {};
  }, [profile, isLoading, id, form]);

  // Handle form field changes
  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle image upload from file
  const handleImageChange = (file) => {
    setImage(file);

    // Create preview
    const reader = new FileReader();
    reader.onload = () => {
      setImagePreview(reader.result);
    };
    reader.readAsDataURL(file);

    return false; // Prevent auto upload
  };

  // Handle camera capture
  const handleCameraCapture = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "user" },
      });

      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        videoRef.current.style.display = "block";
        videoRef.current.play();

        // Hide upload options and show camera controls
        const uploadOptions = document.getElementById("upload-options");
        const controls = document.getElementById("camera-controls");

        if (uploadOptions) {
          uploadOptions.style.display = "none";
        }
        if (controls) {
          controls.style.display = "flex";
        }
      }
    } catch (error) {
      console.error("Error accessing camera:", error);
      toast.error("Unable to access camera. Please check permissions.");
    }
  };

  // Capture photo from camera
  const capturePhoto = () => {
    if (videoRef.current && canvasRef.current) {
      const canvas = canvasRef.current;
      const video = videoRef.current;
      const context = canvas.getContext("2d");

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      context.drawImage(video, 0, 0, canvas.width, canvas.height);

      canvas.toBlob(
        (blob) => {
          const file = new File([blob], "camera-photo.jpg", {
            type: "image/jpeg",
          });
          handleImageChange(file);
          stopCamera();
          setShowImageModal(false);
        },
        "image/jpeg",
        0.8
      );
    }
  };

  // Stop camera stream
  const stopCamera = () => {
    if (videoRef.current && videoRef.current.srcObject) {
      const tracks = videoRef.current.srcObject.getTracks();
      tracks.forEach((track) => track.stop());
      videoRef.current.srcObject = null;
      videoRef.current.style.display = "none";

      // Show upload options and hide camera controls
      const uploadOptions = document.getElementById("upload-options");
      const controls = document.getElementById("camera-controls");

      if (uploadOptions) {
        uploadOptions.style.display = "block";
      }
      if (controls) {
        controls.style.display = "none";
      }
    }
  };

  // Handle file upload from computer
  const handleFileUpload = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  // Handle file input change
  const handleFileInputChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      handleImageChange(file);
      setShowImageModal(false);
    }
  };

  // Handle form submission
  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);

      // Validate form
      await form.validateFields();

      // Prepare data
      const updatedData = { ...formData };
      updatedData.phone = parseInt(`91` + updatedData.phone);

      // Upload image if provided
      if (image) {
        const imageUrl = await uploadImageToCloudinary(image);
        updatedData.image = imageUrl;
      }

      if (!updatedData.image) {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        toast.error("Please upload an image");

        return;
      }

      console.log({ updatedData });
      const isAvilable = profile?.user?.email === updatedData.email;
      console.log({
        isAvilable,
        1: profile?.user?.email,
        2: updatedData.email,
      });

      // Submit application
      if (profile?.user?.email === updatedData.email) {
        const result = await submitApplicationExisted({
          body: updatedData,
          id,
        }).unwrap();
        console.log({ resultAlreadyExisted: result });

        navigate("/become-consultant/success", {
          state: {
            email: formData.email,
            applicationId: result?._id,
          },
        });
      } else {
        const result = await submitApplication(updatedData).unwrap();
        console.log({ result });
        navigate("/become-consultant/verify-otp", {
          state: {
            applicationId: result.applicationId,
            email: formData.email,
          },
        });
      }

      // Clear form and reset state after successful submission
      form.resetFields();
      setFormData({
        id: id,
        phone: "",
        email: "",
        password: "",
        about: "",
        pricePerMinute: "",
        communicationType: [],
        image: "",
        firstName: "",
        lastName: "",
        category: [],
      });
      setImage(null);
      setImagePreview(null);

      toast.success(
        "Application submitted successfully! We'll review it and get back to you soon."
      );
    } catch (error) {
      console.error("Error submitting application:", error);
      toast.error(error?.data?.message || "Failed to submit application");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.5 },
    },
  };

  // Show loading screen while fetching profile data
  if (isLoading && id) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center">
        <div className="text-center">
          <Spin
            size="large"
            style={{
              color: primaryColor,
              fontSize: "24px",
            }}
          />
          <div className="mt-4">
            <Typography.Title level={4} style={{ color: "#6b7280", margin: 0 }}>
              Loading profile data...
            </Typography.Title>
            <Typography.Text type="secondary">
              Please wait while we fetch your information
            </Typography.Text>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <motion.div
        initial="hidden"
        animate="visible"
        variants={containerVariants}
        className="p-4 sm:p-6 lg:p-8 max-w-7xl mx-auto"
      >
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{
            opacity: animateProfile ? 1 : 0,
            y: animateProfile ? 0 : 20,
          }}
          transition={{ duration: 0.5 }}
          className="bg-white rounded-3xl overflow-hidden mb-8 shadow-xl"
          style={{ boxShadow: "0 10px 40px rgba(164, 1, 101, 0.12)" }}
        >
          {/* Header background */}
          <div
            className="h-32 sm:h-40 relative overflow-hidden"
            style={{
              background: `linear-gradient(135deg, ${primaryColor} 0%, ${primaryColor}DD 50%, ${primaryColor}BB 100%)`,
            }}
          >
            {/* Decorative elements */}
            <div className="absolute top-0 right-0 w-32 h-32 sm:w-48 sm:h-48 bg-white opacity-10 rounded-full transform translate-x-1/4 -translate-y-1/4"></div>
            <div className="absolute bottom-0 left-0 w-24 h-24 sm:w-36 sm:h-36 bg-white opacity-10 rounded-full transform -translate-x-1/4 translate-y-1/4"></div>
            <div className="absolute top-1/2 left-1/2 w-16 h-16 sm:w-24 sm:h-24 bg-white opacity-5 rounded-full transform -translate-x-1/2 -translate-y-1/2"></div>

            {/* Floating particles */}
            <div className="absolute top-4 right-8 w-2 h-2 bg-white opacity-30 rounded-full animate-pulse"></div>
            <div
              className="absolute top-12 right-16 w-1 h-1 bg-white opacity-40 rounded-full animate-pulse"
              style={{ animationDelay: "0.5s" }}
            ></div>
            <div
              className="absolute bottom-8 left-12 w-1.5 h-1.5 bg-white opacity-25 rounded-full animate-pulse"
              style={{ animationDelay: "1s" }}
            ></div>
          </div>

          {/* Header content */}
          <div className="px-6 sm:px-8 pb-8 relative">
            <div className="flex flex-col sm:flex-row items-center sm:items-start">
              {/* Avatar */}
              <div className="relative -mt-16 sm:-mt-20 mb-6 sm:mb-0">
                <div
                  className="absolute inset-0 rounded-full animate-pulse"
                  style={{
                    background: `${primaryColor}15`,
                    transform: "scale(1.1)",
                  }}
                />

                <div
                  className="relative cursor-pointer group"
                  onClick={() => setShowImageModal(true)}
                >
                  <Avatar
                    size={120}
                    src={imagePreview}
                    icon={
                      !imagePreview && (
                        <UserOutlined
                          style={{ color: "#888", fontSize: "48px" }}
                        />
                      )
                    }
                    className="border-4 border-white shadow-xl transition-all duration-300 group-hover:shadow-2xl"
                    style={{
                      boxShadow: `0 8px 25px rgba(164, 1, 101, 0.15)`,
                      background: imagePreview ? "transparent" : "#f8f9fa",
                    }}
                  />
                  <div
                    className={`absolute inset-0 flex items-center justify-center rounded-full transition-all duration-300 ${
                      imagePreview
                        ? "opacity-0 group-hover:opacity-100 bg-black bg-opacity-40"
                        : "bg-black bg-opacity-30"
                    }`}
                  >
                    <UploadOutlined
                      style={{
                        fontSize: imagePreview ? "24px" : "36px",
                        color: "white",
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* Title */}
              <div className="sm:ml-8 flex-1 text-center sm:text-left">
                <Title
                  level={2}
                  style={{
                    margin: 0,
                    fontWeight: 600,
                    color: "#1a1a1a",
                    fontSize: "clamp(1.5rem, 4vw, 2rem)",
                  }}
                >
                  Create New Consultant
                </Title>
                <Text
                  type="secondary"
                  className="text-base sm:text-lg mt-2 block"
                  style={{ color: "#6b7280" }}
                >
                  Fill in the details to create a comprehensive consultant
                  profile
                </Text>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Form Content */}
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Row gutter={[32, 32]}>
            {/* Left Column - Personal Information */}
            <Col xs={24} lg={12}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{
                  opacity: animateProfile ? 1 : 0,
                  y: animateProfile ? 0 : 20,
                }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="space-y-6"
              >
                {/* Personal Details Card */}
                <Card
                  className="rounded-2xl shadow-lg overflow-hidden border-0"
                  title={
                    <div className="flex items-center py-2">
                      <div
                        className="flex items-center justify-center w-12 h-12 rounded-xl mr-4 shadow-sm"
                        style={{
                          background: `linear-gradient(135deg, ${primaryColor}15 0%, ${primaryColor}25 100%)`,
                          border: `1px solid ${primaryColor}20`,
                        }}
                      >
                        <UserOutlined
                          style={{ color: primaryColor, fontSize: "20px" }}
                        />
                      </div>
                      <div>
                        <span className="text-xl font-semibold text-gray-800">
                          Personal Information
                        </span>
                        <div className="text-sm text-gray-500 mt-1">
                          Basic details and contact information
                        </div>
                      </div>
                    </div>
                  }
                  headStyle={{
                    borderBottom: `3px solid ${primaryColor}15`,
                    background: `linear-gradient(135deg, #ffffff 0%, ${primaryColor}05 100%)`,
                    padding: "24px 28px",
                  }}
                  bodyStyle={{ padding: "28px" }}
                  style={{
                    boxShadow: "0 12px 40px rgba(164, 1, 101, 0.12)",
                    border: `1px solid ${primaryColor}10`,
                  }}
                >
                  <Row gutter={[20, 24]}>
                    {/* Show all fields if no profile data, otherwise hide prefilled fields */}

                    <Col xs={24} sm={12}>
                      <Form.Item
                        name="email"
                        initialValue={""}
                        label={
                          <span className="text-gray-700 font-medium">
                            Email Address
                          </span>
                        }
                        rules={[
                          {
                            required: true,
                            //check-lowercase

                            transform: (value) => value.toLowerCase(),
                          },
                          {
                            type: "email",
                            message: "Please enter a valid email address",
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter email address"
                          size="large"
                          className="rounded-lg"
                          onChange={(e) =>
                            handleChange("email", e.target.value)
                          }
                          prefix={
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-4 w-4 text-gray-400"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
                              />
                            </svg>
                          }
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12}>
                      <Form.Item
                        name="phone"
                        initialValue={profile?.user?.phone ?? ""}
                        label={
                          <span className="text-gray-700 font-medium">
                            Phone Number
                          </span>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Please enter phone number",
                          },
                          {
                            pattern: /^\d{10}$/,
                            message:
                              "Please enter a valid 10-digit phone number",
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter phone number"
                          maxLength={10}
                          size="large"
                          className="rounded-lg"
                          onChange={(e) =>
                            handleChange("phone", e.target.value)
                          }
                          prefix={<PhoneOutlined className="text-gray-400" />}
                        />
                      </Form.Item>
                    </Col>

                    {/* Email Disclaimer - Full Width */}
                    <Col xs={24}>
                      <div
                        className="p-4 rounded-xl mb-4"
                        style={{
                          background: `linear-gradient(135deg, #fff7e6 0%, #fef3e2 100%)`,
                          border: `1px solid ${primaryColor}30`,
                          borderLeft: `4px solid ${primaryColor}`,
                        }}
                      >
                        <div className="flex items-start gap-3">
                          <div
                            className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center mt-0.5"
                            style={{ backgroundColor: `${primaryColor}20` }}
                          >
                            <svg
                              className="w-4 h-4"
                              style={{ color: primaryColor }}
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path
                                fillRule="evenodd"
                                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                                clipRule="evenodd"
                              />
                            </svg>
                          </div>
                          <div className="flex-1">
                            <h4 className="font-semibold text-gray-800 mb-1 text-sm">
                              Important Notice About Email Usage
                            </h4>
                            <p className="text-gray-600 text-sm leading-relaxed">
                              Please use a different email address that is not
                              linked to your dating account. If you choose to
                              use the same email address currently associated
                              with your dating profile, that dating account will
                              be disabled once your consultant profile is
                              activated.
                            </p>
                          </div>
                        </div>
                      </div>
                    </Col>

                    <Col xs={24} sm={12}>
                      <Form.Item
                        name="firstName"
                        initialValue={profile?.firstName ?? ""}
                        label={
                          <span className="text-gray-700 font-medium">
                            First Name
                          </span>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Please enter first name",
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter first name"
                          size="large"
                          className="rounded-lg"
                          onChange={(e) =>
                            handleChange("firstName", e.target.value)
                          }
                          prefix={<UserOutlined className="text-gray-400" />}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12}>
                      <Form.Item
                        name="lastName"
                        initialValue={profile?.lastName ?? ""}
                        label={
                          <span className="text-gray-700 font-medium">
                            Last Name
                          </span>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Please enter last name",
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter last name"
                          size="large"
                          className="rounded-lg"
                          onChange={(e) =>
                            handleChange("lastName", e.target.value)
                          }
                          prefix={<UserOutlined className="text-gray-400" />}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24}>
                      <Form.Item
                        name="password"
                        label={
                          <span className="text-gray-700 font-medium">
                            Password
                          </span>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Please enter password",
                          },
                          {
                            min: 6,
                            message: "Password must be at least 6 characters",
                          },
                        ]}
                      >
                        <Input.Password
                          placeholder="Enter password"
                          size="large"
                          className="rounded-lg"
                          onChange={(e) =>
                            handleChange("password", e.target.value)
                          }
                          prefix={<LockOutlined className="text-gray-400" />}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24}>
                      <Form.Item
                        name="category"
                        label={
                          <span className="text-gray-700 font-medium">
                            Category
                          </span>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Please select at least one category",
                          },
                        ]}
                      >
                        <Select
                          mode="multiple"
                          placeholder="Select categories"
                          size="large"
                          className="rounded-lg"
                          onChange={(value) => handleChange("category", value)}
                          showSearch
                          optionFilterProp="children"
                          maxTagCount="responsive"
                          suffixIcon={
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-4 w-4 text-gray-400"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          }
                        >
                          {consultantCategory?.map((item, index) => (
                            <Option key={index} value={item.value}>
                              <div className="flex items-center">
                                <span>{item.title}</span>
                              </div>
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24}>
                      <Form.Item
                        name="about"
                        label={
                          <span className="text-gray-700 font-medium">
                            About
                          </span>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Please enter description",
                          },
                        ]}
                      >
                        <Input.TextArea
                          placeholder="Tell us about the consultant's expertise, experience, and what makes you unique..."
                          rows={4}
                          className="rounded-lg"
                          onChange={(e) =>
                            handleChange("about", e.target.value)
                          }
                          showCount
                          maxLength={500}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Card>
              </motion.div>
            </Col>

            {/* Right Column */}
            <Col xs={24} lg={12}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{
                  opacity: animateProfile ? 1 : 0,
                  y: animateProfile ? 0 : 20,
                }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="space-y-6"
              >
                {/* Service Settings Card */}
                <Card
                  className="rounded-2xl shadow-lg overflow-hidden border-0"
                  title={
                    <div className="flex items-center py-2">
                      <div
                        className="flex items-center justify-center w-12 h-12 rounded-xl mr-4 shadow-sm"
                        style={{
                          background: `linear-gradient(135deg, ${primaryColor}15 0%, ${primaryColor}25 100%)`,
                          border: `1px solid ${primaryColor}20`,
                        }}
                      >
                        <CommentOutlined
                          style={{ color: primaryColor, fontSize: "20px" }}
                        />
                      </div>
                      <div>
                        <span className="text-xl font-semibold text-gray-800">
                          Service Settings
                        </span>
                        <div className="text-sm text-gray-500 mt-1">
                          Configure pricing and communication options
                        </div>
                      </div>
                    </div>
                  }
                  headStyle={{
                    borderBottom: `3px solid ${primaryColor}15`,
                    background: `linear-gradient(135deg, #ffffff 0%, ${primaryColor}05 100%)`,
                    padding: "24px 28px",
                  }}
                  bodyStyle={{ padding: "28px" }}
                  style={{
                    boxShadow: "0 12px 40px rgba(164, 1, 101, 0.12)",
                    border: `1px solid ${primaryColor}10`,
                  }}
                >
                  <Row gutter={[20, 24]}>
                    <Col xs={24}>
                      <Form.Item
                        name="pricePerMinute"
                        label={
                          <span className="text-gray-700 font-medium">
                            Price Per Minute (₹)
                          </span>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Please enter price per minute",
                          },
                          {
                            validator: (_, value) => {
                              const num = Number(value);
                              if (isNaN(num) || num < 0 || num > 250) {
                                return Promise.reject(
                                  "Price must be between 0 and 250"
                                );
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <Input
                          type="number"
                          min={0}
                          max={250}
                          size="large"
                          className="rounded-lg"
                          onChange={(e) =>
                            handleChange(
                              "pricePerMinute",
                              Number(e.target.value)
                            )
                          }
                          addonBefore={<TbCurrencyRupee />}
                          suffix="per minute"
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24}>
                      <Form.Item
                        name="communicationType"
                        label={
                          <span className="text-gray-700 font-medium">
                            Communication Types
                          </span>
                        }
                        rules={[
                          {
                            required: true,
                            message:
                              "Please select at least one communication type",
                          },
                        ]}
                      >
                        <div className="bg-gray-50 p-4 rounded-lg">
                          <Checkbox.Group
                            onChange={(values) =>
                              handleChange("communicationType", values)
                            }
                          >
                            <div className="flex flex-col gap-3">
                              <Checkbox value="phone" className="text-base">
                                <div className="flex items-center">
                                  <PhoneOutlined className="mr-2" />
                                  Phone Call
                                </div>
                              </Checkbox>
                              <Checkbox value="chat" className="text-base">
                                <div className="flex items-center">
                                  <CommentOutlined className="mr-2" />
                                  Chat
                                </div>
                              </Checkbox>
                            </div>
                          </Checkbox.Group>
                        </div>
                      </Form.Item>
                    </Col>

                    {/* Additional spacing to match left column height */}
                    <Col xs={24}>
                      <div className="space-y-6">
                        {/* Pricing Guidelines */}
                        <div
                          className="p-4 rounded-xl"
                          style={{
                            background: `linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)`,
                            border: `1px solid ${primaryColor}20`,
                            borderLeft: `4px solid ${primaryColor}`,
                          }}
                        >
                          <div className="flex items-start gap-3">
                            <div
                              className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center mt-0.5"
                              style={{ backgroundColor: `${primaryColor}20` }}
                            >
                              <TbCurrencyRupee
                                className="w-4 h-4"
                                style={{ color: primaryColor }}
                              />
                            </div>
                            <div className="flex-1">
                              <h4 className="font-semibold text-gray-800 mb-1 text-sm">
                                Pricing Guidelines
                              </h4>
                              <p className="text-gray-600 text-sm leading-relaxed">
                                Set competitive rates based on your expertise.
                                Consider market rates and your experience level
                                when pricing your services.
                              </p>
                            </div>
                          </div>
                        </div>

                        {/* Communication Tips */}
                        <div
                          className="p-4 rounded-xl"
                          style={{
                            background: `linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)`,
                            border: `1px solid #22c55e30`,
                            borderLeft: `4px solid #22c55e`,
                          }}
                        >
                          <div className="flex items-start gap-3">
                            <div className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center mt-0.5 bg-green-100">
                              <CommentOutlined className="w-4 h-4 text-green-600" />
                            </div>
                            <div className="flex-1">
                              <h4 className="font-semibold text-gray-800 mb-1 text-sm">
                                Communication & Earnings
                              </h4>
                              <p className="text-gray-600 text-sm leading-relaxed mb-2">
                                <strong>Chat:</strong> Free for users - Use this
                                to build rapport and convince users to switch to
                                paid calls.
                              </p>
                              <p className="text-gray-600 text-sm leading-relaxed">
                                <strong>Phone Call:</strong> Paid service - This
                                is where you earn money. Encourage users to
                                upgrade from chat to calls for better
                                consultation.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Card>
              </motion.div>
            </Col>
          </Row>

          {/* Submit Button Section */}
          <Row justify="center" className="mt-8">
            <Col xs={24} sm={20} md={16} lg={12} xl={10}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{
                  opacity: animateProfile ? 1 : 0,
                  y: animateProfile ? 0 : 20,
                }}
                transition={{ duration: 0.5, delay: 0.3 }}
                className="text-center"
              >
                <div className="mb-4">
                  <Text className="text-lg font-semibold text-gray-800 block">
                    Ready to create consultant profile?
                  </Text>
                  <Text type="secondary" className="text-sm">
                    Please review all information before submitting
                  </Text>
                </div>

                <Button
                  type="primary"
                  htmlType="submit"
                  onClick={() => {
                    const status = form
                      .getFieldsError()
                      .filter((item) => item.errors.length > 0);
                    // console.log({ status });
                    if (status.length > 0) {
                      toast("Please enter all fields", { type: "error" });
                      window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                      });
                    }
                  }}
                  icon={<SaveOutlined />}
                  loading={isSubmitting || isSubmittingApplication}
                  size="large"
                  className="px-12 py-2 h-12 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
                  style={{
                    backgroundColor: primaryColor,
                    borderColor: primaryColor,
                    background: `linear-gradient(135deg, ${primaryColor} 0%, ${primaryColor}DD 100%)`,
                    minWidth: "200px",
                  }}
                >
                  {isSubmitting || isSubmittingApplication
                    ? "Submitting Application..."
                    : "Submit Application"}
                </Button>
              </motion.div>
            </Col>
          </Row>
        </Form>

        {/* Custom styles */}
        <style jsx="true">{`
          .ant-form-item-label > label {
            color: #374151 !important;
            font-weight: 500;
            font-size: 14px;
          }

          .ant-select-focused:not(.ant-select-disabled).ant-select:not(
              .ant-select-customize-input
            )
            .ant-select-selector {
            border-color: ${primaryColor} !important;
            box-shadow: 0 0 0 2px ${primaryColor}20 !important;
          }

          .ant-input:focus,
          .ant-input-focused {
            border-color: ${primaryColor} !important;
            box-shadow: 0 0 0 2px ${primaryColor}20 !important;
          }

          .ant-input:hover {
            border-color: ${primaryColor}80 !important;
          }

          .ant-input-affix-wrapper:hover {
            border-color: ${primaryColor}80 !important;
          }

          .ant-input-affix-wrapper:focus,
          .ant-input-affix-wrapper-focused {
            border-color: ${primaryColor} !important;
            box-shadow: 0 0 0 2px ${primaryColor}20 !important;
          }

          .ant-checkbox-checked .ant-checkbox-inner {
            background-color: ${primaryColor} !important;
            border-color: ${primaryColor} !important;
          }

          .ant-checkbox-wrapper:hover .ant-checkbox-inner {
            border-color: ${primaryColor} !important;
          }

          .ant-select:hover .ant-select-selector {
            border-color: ${primaryColor}80 !important;
          }

          .ant-upload-list-item:hover {
            background-color: ${primaryColor}05 !important;
          }

          .ant-card {
            transition: all 0.3s ease;
          }

          .ant-card:hover {
            transform: translateY(-2px);
            box-shadow: 0 12px 40px rgba(164, 1, 101, 0.12) !important;
          }
        `}</style>
      </motion.div>

      {/* Image Upload Modal */}
      <Modal
        title={
          <div className="flex items-center gap-3 pb-2">
            <div
              className="flex items-center justify-center w-12 h-12 rounded-xl shadow-sm"
              style={{
                background: `linear-gradient(135deg, ${primaryColor}15 0%, ${primaryColor}25 100%)`,
                border: `1px solid ${primaryColor}20`,
              }}
            >
              <UploadOutlined
                style={{ color: primaryColor, fontSize: "20px" }}
              />
            </div>
            <div>
              <span className="text-xl font-semibold text-gray-800">
                Add Profile Photo
              </span>
              <div className="text-sm text-gray-500 mt-1">
                Choose your preferred method
              </div>
            </div>
          </div>
        }
        open={showImageModal}
        onCancel={() => {
          setShowImageModal(false);
          stopCamera();
        }}
        footer={null}
        centered
        width={600}
        className="image-upload-modal"
        styles={{
          header: {
            borderBottom: `2px solid ${primaryColor}15`,
            paddingBottom: "20px",
            marginBottom: "24px",
          },
        }}
      >
        <div className="py-2">
          {/* Camera Preview Section */}
          <div className="mb-6" id="camera-preview-container">
            <video
              ref={videoRef}
              className="w-full rounded-xl shadow-lg border-2 border-gray-200"
              style={{
                maxHeight: "350px",
                display: "none",
                objectFit: "cover",
              }}
              autoPlay
              playsInline
            />

            <div
              className="mt-4 flex justify-center gap-4"
              id="camera-controls"
              style={{ display: "none" }}
            >
              <button
                onClick={capturePhoto}
                className="flex items-center gap-3 px-6 py-3 rounded-xl font-semibold text-white shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
                style={{
                  background: `linear-gradient(135deg, ${primaryColor} 0%, ${primaryColor}DD 100%)`,
                }}
              >
                <CameraOutlined className="text-lg" />
                Capture Photo
              </button>
              <button
                onClick={stopCamera}
                className="flex items-center gap-3 px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-xl font-semibold shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-300"
              >
                Cancel
              </button>
            </div>
          </div>

          {/* Options Section */}
          <div id="upload-options">
            <p className="text-gray-600 mb-6 text-center text-lg">
              How would you like to add your profile photo?
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {/* Camera Option */}
              <div
                onClick={handleCameraCapture}
                className="group cursor-pointer p-6 rounded-2xl border-2 border-gray-200 hover:border-blue-400 bg-gradient-to-br from-blue-50 to-blue-100 hover:from-blue-100 hover:to-blue-200 transition-all duration-300 transform hover:scale-105 hover:shadow-lg"
              >
                <div className="flex flex-col items-center text-center space-y-4">
                  <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center shadow-lg group-hover:shadow-xl transition-all duration-300">
                    <CameraOutlined className="text-2xl text-white" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-1">
                      Take Photo
                    </h3>
                    <p className="text-sm text-gray-600">
                      Use your camera to capture a new photo
                    </p>
                  </div>
                  <div className="w-full h-1 bg-blue-300 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
              </div>

              {/* Upload Option */}
              <div
                onClick={handleFileUpload}
                className="group cursor-pointer p-6 rounded-2xl border-2 border-gray-200 hover:border-green-400 bg-gradient-to-br from-green-50 to-green-100 hover:from-green-100 hover:to-green-200 transition-all duration-300 transform hover:scale-105 hover:shadow-lg"
              >
                <div className="flex flex-col items-center text-center space-y-4">
                  <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center shadow-lg group-hover:shadow-xl transition-all duration-300">
                    <FolderOpenOutlined className="text-2xl text-white" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-1">
                      Upload Photo
                    </h3>
                    <p className="text-sm text-gray-600">
                      Choose an existing photo from your device
                    </p>
                  </div>
                  <div className="w-full h-1 bg-green-300 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
              </div>
            </div>

            {/* Tips Section */}
            <div className="mt-8 p-4 bg-gray-50 rounded-xl border border-gray-200">
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-yellow-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <svg
                    className="w-4 h-4 text-yellow-600"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-800 text-sm mb-1">
                    Photo Tips
                  </h4>
                  <p className="text-gray-600 text-sm">
                    Use a clear, well-lit photo where your face is clearly
                    visible. This helps build trust with potential clients.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      {/* Hidden file input */}
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleFileInputChange}
        style={{ display: "none" }}
      />

      {/* Hidden canvas for camera capture */}
      <canvas ref={canvasRef} style={{ display: "none" }} />

      <ToastContainer />
    </div>
  );
};
